import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {trackEvent} from '../tracking/amplitude/TrackingV2';

const mutation = graphql`
	mutation toggleReportFavoriteMutation($input: ToggleReportFavoriteInput!) {
		toggleReportFavorite(input: $input) {
			savedReport {
				node {
					id
					favorite
				}
			}
		}
	}
`;

function getOptimisticResponse(input) {
	return {
		toggleReportFavorite: {
			savedReport: {
				node: {
					id: input.reportId,
					favorite: !input.isFavorite,
				},
			},
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	const cleanedInput = omit(input, ['isFavorite']);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}};

	trackEvent('Standard Report', 'Favorite');

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
